var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 32H32M19.974 5.85285C19.974 5.85285 19.974 8.57723 22.6984 11.3016C25.4228 14.026 28.1471 14.026 28.1471 14.026M9.19938 26.9801L14.9206 26.1628C15.7458 26.0449 16.5106 25.6625 17.1001 25.0731L30.8715 11.3016C32.3762 9.79697 32.3762 7.35748 30.8715 5.85285L28.1472 3.12847C26.6425 1.62384 24.203 1.62384 22.6984 3.12847L8.92694 16.8999C8.33746 17.4894 7.95508 18.2542 7.83719 19.0794L7.01988 24.8006C6.83825 26.072 7.928 27.1617 9.19938 26.9801Z",
    stroke: "#25A249",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.eb5d11ddb6c34dcc154d5a3536e9a30f.svg";
export { ForwardRef as ReactComponent };